import { useGameStore } from '../state/gameStore';
import { PanelShell } from './PanelShell';

export function RaidPanel() {
  const damage = useGameStore((state) => state.raidDamage);
  const target = 25_000;
  const progress = Math.min(100, (damage / target) * 100);
  return (
    <PanelShell eyebrow="WEEK 01 // GLOBAL RAID" title="MARGIN CALLOSSUS">
      <div className="boss-portrait" aria-label="Margin Callossus boss silhouette">
        <span />
        <strong>MC</strong>
      </div>
      <p className="lede">
        Every correct daily call punches the same giant finance bastard. No whales. No paid
        damage. Just collective bad judgment.
      </p>
      <div className="health-label">
        <span>COMMUNITY DAMAGE</span>
        <strong>
          {damage.toLocaleString()} / {target.toLocaleString()}
        </strong>
      </div>
      <div className="health-track">
        <span style={{ width: `${progress}%` }} />
      </div>
      <div className="stat-grid">
        <div>
          <span>GHOSTS ACTIVE</span>
          <strong>128</strong>
        </div>
        <div>
          <span>YOUR DAMAGE</span>
          <strong>420</strong>
        </div>
        <div>
          <span>TIME LEFT</span>
          <strong>3D 14H</strong>
        </div>
      </div>
    </PanelShell>
  );
}

